// helpers/validateRequired.js
/**
 * Returns an array of fields whose `required` flag is true
 * but whose value is missing or empty in formValues.
 *
 * @param {Array<Object>} fields      - full field definition array
 * @param {Object}        formValues  - the live values from RHF (watch / getValues)
 * @returns {Array<Object>}           - fields that fail the required check
 */
export default function validateRequired(fields = [], formValues = {}) {
    const isEmpty = (val) => {
      if (val == null) return true;                // null / undefined
      if (typeof val === 'string') return val.trim() === '';
      if (Array.isArray(val))   return val.length === 0;
      if (typeof val === 'object')
        return Object.keys(val).length === 0;      // empty object
      return false;                               // numbers, booleans
    };
  
    return fields.filter((field) => {
      if (!field.required) return false;           // not required → skip
      if (field.hidden)   return false;           // hidden fields → ignore
      const value = formValues[field.name];
      return isEmpty(value);
    });
  }